import "./App.css";
import "./Login.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { lazy, Suspense } from "react";
import ScrollToTop from "./ScrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const TramoHomePage = lazy(() => import("./TramoHomePage"));
const TramoAboutPage = lazy(() => import("./TramoAboutPage"));
const TramoOurOffer = lazy(() => import("./TramoOurOffer"));
const TramoAccountent = lazy(() => import("./TramoAccountent"));
// const TramoFormApply = lazy(() => import("./TramoFormApply"));
const TramoBlog = lazy(() => import("./TramoBlog"));
const TramoFintechPage = lazy(() => import("./TramoFintechPage"));
const TramoFintech1 = lazy(() => import("./TramoFintech1"));
const TramoFintech2 = lazy(() => import("./TramoFintech2"));
const TramoFintech3 = lazy(() => import("./TramoFintech3"));
const TramoContactPage = lazy(() => import("./TramoContactPage"));
const TramoRefundPolicy = lazy(() => import("./TramoRefundPolicy"));
const TramoTermAndCondition = lazy(() => import("./TramoTermAndCondition"));
const TramoPrivacyPolicy = lazy(() => import("./TramoPrivacyPolicy"));
// const TramoGrevience = lazy(() => import("./TramoGrevience"));
// const Signup = lazy(() => import("./Signup"));
// const Login = lazy(() => import("./LoginPage"));
function App() {
  return (
    <>
      <HelmetProvider>
        <Router>
          <ScrollToTop />
          <Suspense fallback={<div style={{ minHeight: "100vh" }}></div>}>
            <Routes>
              <Route path="/" element={<TramoHomePage />} />
              <Route path="/about" element={<TramoAboutPage />} />
              <Route path="/Our-offer" element={<TramoOurOffer />} />
              <Route exact path="/account" element={<TramoAccountent />} />
              {/* <Route path="/apply" element={<TramoFormApply />} /> */}
              <Route path="/blog" element={<TramoBlog />} />
              <Route path="/FintechPage" element={<TramoFintechPage />} />
              <Route path="/FintechPage1" element={<TramoFintech1 />} />
              <Route path="/FintechPage2" element={<TramoFintech2 />} />
              <Route path="/FintechPage3" element={<TramoFintech3 />} />
              <Route path="/contact-us" element={<TramoContactPage />} />
              <Route path="/refund-policy" element={<TramoRefundPolicy />} />
              <Route path="/Terms" element={<TramoTermAndCondition />} />
              <Route path="/Pricacy-policy" element={<TramoPrivacyPolicy />} />
              {/* <Route path="/grevience" element={<TramoGrevience />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} /> */}
            </Routes>
          </Suspense>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </Router>
      </HelmetProvider>
    </>
  );
}

export default App;
